export function openAnchor() {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    const label = document.getElementById(hash);
    if (label) {
      const checkbox = document.getElementById(label.getAttribute('for'));
      if (checkbox) {
        checkbox.checked = true;
      }
    }
  }
}

function openAnchorInit() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      openAnchor();
    });
  } else {
    openAnchor();
  }

  window.addEventListener('hashchange', () => {
    openAnchor();
  });
}

export default openAnchorInit();
